import { Divider } from '@/components/Divider'
import { color, fontHeading3, spacing } from '@/materials'
import styled from '@emotion/styled'
import * as React from 'react'

/**
 * @deprecated Use <Divider variant="strong" />
 */
export const StrongDivider = styled('div')`
  height: 0;
  overflow: hidden;
  width: 100%;
  color: var(--text-color);
  border-bottom: 3px solid ${color.text};
`

/**
 * @deprecated Use <Divider variant="weak" />
 */
export const WeakDivider = styled('div')`
  height: 0;
  overflow: hidden;
  border-bottom: 1px solid ${color.grey['300']};
`

export const LabeledDivider = ({ label }: { label: React.ReactNode }) => (
  <Root>
    <Divider variant="strong" />
    <DividerHeading>{label}</DividerHeading>
  </Root>
)

const Root = styled('div')`
  ${spacing.mb6};
`

export const DividerHeading = styled('div')`
  ${fontHeading3};
  margin-top: 30px;
  color: var(--text-color);
  font-family: var(--font-sans-serif);
  font-weight: bold;
  font-size: 20px;
  line-height: 24px;
  text-transform: uppercase;
`
